import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/pages/home/home'
import MeetDrDeborahNew from '@/pages/meet-dr-deborah-new/meet-dr-deborah-new'
import MeetTheTeam from '@/pages/meet-the-team/meet-the-team'
import WhatSetsUsApart from '@/pages/what-sets-us-apart/what-sets-us-apart'
import Contests from '@/pages/contests/contests'
import GetTheApp from '@/pages/get-the-app/get-the-app'
import OfficeVisits from '@/pages/office-visits/office-visits'
import FinancialInformation from '@/pages/financial-information/financial-information'
import Testimonials from '@/pages/testimonials/testimonials'
import BeforeAndAfter from '@/pages/before-and-after/before-and-after'
import AboCertification from '@/pages/abo-certification/abo-certification'
import OfficeTour from '@/pages/office-tour/office-tour'
import PatientForms from '@/pages/patient-forms/patient-forms'
import LifeWithBraces from '@/pages/life-with-braces/life-with-braces'
import TypesOfBraces from '@/pages/types-of-braces/types-of-braces'
import TypesOfAppliances from '@/pages/types-of-appliances/types-of-appliances'
import Inbrace from '@/pages/inbrace/inbrace'
import RetainerInstructions from '@/pages/retainer-instructions/retainer-instructions'
import EmergencyCare from '@/pages/emergency-care/emergency-care'
import OrthodonticRetention from '@/pages/orthodontic-retention/orthodontic-retention'
import ForAdults from '@/pages/for-adults/for-adults'
import ColorMyBraces from '@/pages/color-my-braces/color-my-braces'
import CommonOrthodonticIssues from '@/pages/common-orthodontic-issues/common-orthodontic-issues'
import EarlyOrthodonticTreatment from '@/pages/early-orthodontic-treatment/early-orthodontic-treatment'
import SurgicalOrthodontics from '@/pages/surgical-orthodontics/surgical-orthodontics'
import IteroElement from '@/pages/itero-element/itero-element'
import TmjTmd from '@/pages/tmj-tmd/tmj-tmd'
import SleepApnea from '@/pages/sleep-apnea/sleep-apnea'
import InvisalignTreatment from '@/pages/invisalign-treatment/invisalign-treatment'
import InvisalignTreatmentForTeens from '@/pages/invisalign-treatment-for-teens/invisalign-treatment-for-teens'
import InOvation from '@/pages/in-ovation/in-ovation'
import RochesterOfficeLocation from '@/pages/rochester-office-location/rochester-office-location'
import AppointmentRequest from '@/pages/appointment-request/appointment-request'
import ReferAFriend from '@/pages/refer-a-friend/refer-a-friend'
import ThankYou from '@/pages/thank-you/thank-you'
import Accessibility from '@/pages/accessibility/accessibility'
import Sitemap from '@/pages/sitemap/sitemap'
// const AboutUs = () => import(/* webpackChunkName: "group" */ '@/pages/about-us/about-us')
// import PageNotFound from '@/pages/404/404'
import scrollBehavior from '@/shared/functionality/scroll-behavior'
import Styleguide from '@/styleguide/styleguide'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      navigation: true,
      component: Home
    },
    {
      path: '/meet-dr-deborah-new',
      name: 'Meet Dr. Deborah New',
      navigation: true,
      component: MeetDrDeborahNew
    },
    {
      path: '/meet-the-team',
      name: 'Meet The Team',
      navigation: true,
      component: MeetTheTeam
    },
    {
      path: '/what-sets-us-apart',
      name: 'What Sets Us Apart',
      navigation: true,
      component: WhatSetsUsApart
    },
    {
      path: '/contests',
      name: 'Contests',
      navigation: true,
      component: Contests
    },
    {
      path: '/get-the-app',
      name: 'Get the App',
      navigation: false,
      component: GetTheApp
    },
    {
      path: '/office-visits',
      name: 'Office Visits',
      navigation: true,
      component: OfficeVisits
    },
    {
      path: '/financial-information',
      name: 'Financial Information',
      navigation: true,
      component: FinancialInformation
    },
    {
      path: '/testimonials',
      name: 'Testimonials',
      navigation: true,
      component: Testimonials
    },
    {
      path: '/before-and-after',
      name: 'Before And After',
      navigation: true,
      component: BeforeAndAfter
    },
    {
      path: '/abo-certification',
      name: 'ABO Certification',
      navigation: true,
      component: AboCertification
    },
    {
      path: '/office-tour',
      name: 'Office Tour',
      navigation: true,
      component: OfficeTour
    },
    {
      path: '/patient-forms',
      name: 'Patient Forms',
      navigation: true,
      component: PatientForms
    },
    {
      path: '/life-with-braces',
      name: 'Life with Braces',
      navigation: true,
      component: LifeWithBraces
    },
    {
      path: '/types-of-braces',
      name: 'Types of Braces',
      navigation: true,
      component: TypesOfBraces
    },
    {
      path: '/types-of-appliances',
      name: 'Types of Appliances',
      navigation: true,
      component: TypesOfAppliances
    },
    {
      path: '/inbrace',
      name: 'INBRACE',
      navigation: false,
      component: Inbrace
    },
    {
      path: '/retainer-instructions',
      name: 'Retainer Instructions',
      navigation: true,
      component: RetainerInstructions
    },
    {
      path: '/emergency-care',
      name: 'Emergency Care',
      navigation: true,
      component: EmergencyCare
    },
    {
      path: '/orthodontic-retention',
      name: 'Orthodontic Retention',
      navigation: true,
      component: OrthodonticRetention
    },
    {
      path: '/for-adults',
      name: 'For Adults',
      navigation: true,
      component: ForAdults
    },
    {
      path: '/color-my-braces',
      name: 'Color My Braces',
      navigation: true,
      component: ColorMyBraces
    },
    {
      path: '/common-orthodontic-issues',
      name: 'Common Orthodontic Issues',
      navigation: true,
      component: CommonOrthodonticIssues
    },
    {
      path: '/early-orthodontic-treatment',
      name: 'Early Orthodontic Treatment',
      navigation: true,
      component: EarlyOrthodonticTreatment
    },
    {
      path: '/surgical-orthodontics',
      name: 'Surgical Orthodontics',
      navigation: true,
      component: SurgicalOrthodontics
    },
    {
      path: '/itero-element',
      name: 'iTero® Element™',
      navigation: true,
      component: IteroElement
    },
    {
      path: '/tmj-tmd',
      name: 'TMJ-TMD',
      navigation: true,
      component: TmjTmd
    },
    {
      path: '/sleep-apnea',
      name: 'Sleep Apnea',
      navigation: true,
      component: SleepApnea
    },
    {
      path: '/invisalign-treatment',
      name: 'Invisalign® Treatment',
      navigation: true,
      component: InvisalignTreatment
    },
    {
      path: '/invisalign-treatment-for-teens',
      name: 'Invisalign® Treatment for Teens',
      navigation: true,
      component: InvisalignTreatmentForTeens
    },
    {
      path: '/in-ovation',
      name: 'In-Ovation®',
      navigation: true,
      component: InOvation
    },
    {
      path: '/rochester-office-location',
      name: 'Rochester Office Location',
      navigation: true,
      component: RochesterOfficeLocation
    },
    {
      path: '/appointment-request',
      name: 'Appointment Request',
      navigation: true,
      component: AppointmentRequest
    },
    {
      path: '/refer-a-friend',
      name: 'Refer A Friend',
      navigation: true,
      component: ReferAFriend
    },
    {
      path: '/thank-you',
      name: 'Thank You',
      navigation: true,
      component: ThankYou
    },
    {
      path: '/accessibility',
      name: 'Accessibility',
      navigation: true,
      component: Accessibility
    },
    {
      path: '/sitemap',
      name: 'Sitemap',
      navigation: true,
      component: Sitemap
    },
    {
      path: '/styleguide',
      name: 'Styleguide',
      navigation: false,
      component: Styleguide
    },
    {
      path: '/*',
      name: 'page-not-found',
      navigation: false,
      component: Home
    }
  ],
  scrollBehavior
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js